export default {
  namespaced: true,
  state: {
    isSearchOpen: false,
  },
  mutations: {
    toggleSearchOpen: (state) => {
      state.isSearchOpen = !state.isSearchOpen;
    },
  },
};
